import axiosInstance from '@/core/api'
import type {
	PurchaseQuotaRequest,
	GetQuotaPurchaseHistoryQuery,
	QuotaCurrentResponse,
	QuotaPurchaseHistoryResponse,
} from '../../types'

export class QuotaService {
	static async getCurrentQuota(): Promise<QuotaCurrentResponse> {
		const { data } = await axiosInstance.get<QuotaCurrentResponse>(
			'/admin/quota/current',
		)
		return data
	}

	static async purchaseQuota(
		body: PurchaseQuotaRequest,
	): Promise<{ success: boolean; message?: string }> {
		const { data } = await axiosInstance.post<{
			success: boolean
			message?: string
		}>('/admin/quota/purchase', body)
		return data
	}

	static async getQuotaPurchaseHistory(
		query?: GetQuotaPurchaseHistoryQuery,
	): Promise<QuotaPurchaseHistoryResponse> {
		const { data } = await axiosInstance.get<QuotaPurchaseHistoryResponse>(
			'/admin/quota/history',
			{ params: query },
		)
		return data
	}
}
